import React from 'react'

function NotFound() {
  return (
    <div className="notFound flex justify-center items-center w-screen h-screen text-[3vmax] font-bold">
       Page Not Found
    </div>
  )
}

export default NotFound